import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { isValidNumber } from './phone';

const isEmpty = (value) => value === undefined || value === null || value === '' || value === 'undefined';
const join = (rules) => (value, data) => rules.map((rule) => rule(value, data)).filter((error) => !!error)[0]; // first error

export const months = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
];

export function validateEmail(value) {
  if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return 'Invalid email address';
  }
}

export function required(value) {
  if (isEmpty(value)) {
    return '* Field is required';
  }
}

export function integer(value) {
  if (!Number.isInteger(Number(value))) {
    return 'Must be an integer';
  }
}

export function validateExpMonth(value) {
  if (!isEmpty(value) && !~months.indexOf(value.toString())) {
    return 'Enter a month between 1 and 12';
  }
}

export function validateExpYear(value) {
  const thisYear = new Date().getFullYear();
  if (!isEmpty(value) && (value.toString().length !== 4 || value < thisYear)) {
    return 'Enter a year in the future';
  }
}

export function validateCreditCard(value) {
  function valid_credit_card(ccNum) {
    // Luhn algorithm https://gist.github.com/DiegoSalazar/4075533
    // accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(ccNum) || (ccNum.replace(/\s/g, '').length < 13 || ccNum.replace(/\s/g, '').length > 16)) {
      return false;
    }

    let nCheck = 0;
    let bEven = false;
    ccNum = ccNum.replace(/\D/g, '');

    for (let n = ccNum.length - 1; n >= 0; n--) {
      const cDigit = ccNum.charAt(n);
      let nDigit = parseInt(cDigit, 10);

      if (bEven) {
        if ((nDigit *= 2) > 9) nDigit -= 9;
      }

      nCheck += nDigit;
      bEven = !bEven;
    }

    return nCheck % 10 === 0;
  }

  if (!isEmpty(value) && !valid_credit_card(value)) {
    return 'Please enter a valid card number';
  }
}

export function validatePhoneNumberCheckout(value) {
  if (!isEmpty(value)) {
    if (!isValidNumber(value)) {
      return 'Invalid phone number';
    }
  }
}

export function validatePhoneNumber(value) {
  if (!isEmpty(value)) {
    const { phoneNumber, selectedCountry } = value;

    if (phoneNumber.length === 1) {
      return false;
    }

    const phone = parsePhoneNumberFromString(
      phoneNumber,
      selectedCountry.countryCode
    );

    return phone?.isValid();
  }
}

export const validatePhoneWithCountryCode = (values) => {
  const errors = {};

  if (!values.phoneNumber) {
    errors.phoneNumber = 'The phone number is required';
  } else if (!validatePhoneNumber(values)) {
    errors.phoneNumber = 'Whoops! That is not a valid phone number';
  }

  return errors;
};

export function validateCvc(value) {
  if (!isEmpty(value) && (value.length < 3 || value.length > 4)) {
    return 'Security code should be at least 3 digits';
  }
}

export function validateAcceptTos(value) {
  if (!!!value) {
    return 'Please accept the terms and conditions';
  }
}

export function validateZip(value) {
  if (!isEmpty(value) && value.length < 5) {
    return 'Zip code should be at least 5 characters';
  }
}

export function createValidator(rules) {
  return (data = {}) => {
    const errors = {};
    Object.keys(rules).forEach((key) => {
      const rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
      const error = rule(data[key], data);
      if (error) {
        errors[key] = error;
      }
    });
    return errors;
  };
}

export function isValidUrl(value) {
  // Copyright (c) 2010-2013 Diego Perini, MIT licensed
  // https://gist.github.com/dperini/729294
  // see also https://mathiasbynens.be/demo/url-regex
  // modified to allow protocol-relative URLs
  return /^(?:(?:(?:https?):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
    value
  );
}
